(function () {
  var GAP = 40;
  var BREAKPOINT = 990;
  var PADDING_TOP = 32;
  var PADDING_BOTTOM = 12;

  function layoutContainer(container) {
    var columns = Array.prototype.slice.call(
      container.querySelectorAll(':scope > .navigation__column:not(.navigation__column--promotion)')
    );
    if (!columns.length) return;

    if (window.innerWidth < BREAKPOINT) {
      resetContainer(container, columns);
      return;
    }

    var numSlots = Math.min(columns.length, 5);
    var containerWidth = container.offsetWidth;
    if (!containerWidth) return;
    var slotWidth = containerWidth / numSlots;

    var slotHeights = new Array(numSlots).fill(0);
    var slotUsed = new Array(numSlots).fill(false);

    container.style.position = 'relative';
    container.style.paddingTop = '0';
    container.style.paddingBottom = '0';

    columns.forEach(function (col) {
      var title = col.querySelector('.navigation__column-title');
      if (title) {
        title.style.borderTop = '';
        title.style.paddingTop = '';
      }

      col.style.position = 'absolute';
      col.style.top = '0';
      col.style.left = '0';
      col.style.width = (slotWidth - GAP) + 'px';
      col.style.margin = '0';

      var shortestIndex = 0;
      for (var i = 1; i < numSlots; i++) {
        if (slotHeights[i] < slotHeights[shortestIndex]) shortestIndex = i;
      }

      if (slotUsed[shortestIndex] && title) {
        title.style.borderTop = '1px solid rgba(255, 255, 255, 0.15)';
        title.style.paddingTop = '14px';
      }
      slotUsed[shortestIndex] = true;

      var colHeight = col.offsetHeight;

      col.style.left = (shortestIndex * slotWidth) + 'px';
      col.style.top = (slotHeights[shortestIndex] + PADDING_TOP) + 'px';

      slotHeights[shortestIndex] += colHeight + GAP;
    });

    var maxHeight = Math.max.apply(null, slotHeights);
    container.style.height = (maxHeight + PADDING_TOP + PADDING_BOTTOM) + 'px';

    renderDividers(container, numSlots, slotWidth, maxHeight);
  }

  function renderDividers(container, numSlots, slotWidth, maxHeight) {
    container.querySelectorAll('.navigation__masonry-divider').forEach(function (el) { el.remove(); });
    for (var i = 1; i < numSlots; i++) {
      var divider = document.createElement('div');
      divider.className = 'navigation__masonry-divider';
      divider.style.position = 'absolute';
      divider.style.top = PADDING_TOP + 'px';
      divider.style.left = (i * slotWidth - (GAP / 2)) + 'px';
      divider.style.width = '1px';
      divider.style.height = maxHeight + 'px';
      divider.style.background = 'rgba(255, 255, 255, 0.15)';
      divider.style.pointerEvents = 'none';
      container.appendChild(divider);
    }
  }

  function resetContainer(container, columns) {
    container.style.position = '';
    container.style.height = '';
    container.style.paddingTop = '';
    container.style.paddingBottom = '';
    columns.forEach(function (col) {
      col.style.position = '';
      col.style.width = '';
      col.style.top = '';
      col.style.left = '';
      col.style.margin = '';
      var title = col.querySelector('.navigation__column-title');
      if (title) {
        title.style.borderTop = '';
        title.style.paddingTop = '';
      }
    });
    container.querySelectorAll('.navigation__masonry-divider').forEach(function (el) { el.remove(); });
  }

  function initAll() {
    document.querySelectorAll('.navigation__columns').forEach(function (container) {
      if (container.closest('.mobile-navigation-drawer')) return;
      layoutContainer(container);
    });
  }

  function debounce(fn, wait) {
    var t;
    return function () {
      clearTimeout(t);
      var args = arguments;
      t = setTimeout(function () { fn.apply(null, args); }, wait);
    };
  }

  document.addEventListener('DOMContentLoaded', initAll);
  window.addEventListener('load', initAll);
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(initAll);
  }
  window.addEventListener('resize', debounce(initAll, 150));
})();